<template>
  <li class="border-b border-pink last-of-type:border-none">
    <SiteLink
      :content="{ link: content.link }"
      class="pb-5 lg:py-10 block cursor-pointer lg:flex lg:items-end lg:gap-9 group relative"
      @mousemove.passive="handleMouseMove"
    >
      <ResponsiveImage
        :media="content.image"
        class="aspect-35/17 object-cover mb-5 lg:absolute lg:w-75 lg:aspect-6/5 lg:opacity-0 lg:group-hover:opacity-100 lg:transition-all lg:ease-linear lg:duration-400 pointer-events-none will-change-transform image-fx"
        :style="[{ transform: `translate3d(${x}px, ${y}px, 0)` }]"
      />
      <div
        class="mb-1 lg:mb-0 flex items-end lg:items-center lg:justify-between gap-2 lg:order-2 lg:grow lg:relative lg:z-10"
      >
        <p class="font-subtitle text-[50px] lg:text-8xl leading-14 lg:leading-26 uppercase">
          {{ content.title }}
        </p>
        <div
          class="w-17.5 aspect-square rounded-full border border-pink flex items-center justify-center shrink-0"
        >
          <IconSprite
            id="diagonal_arrow"
            class="text-pink text-[20px] group-hover:translate-x-1 group-hover:-translate-y-1 transition-[translateX_translateY]"
          />
        </div>
      </div>
      <p class="text-pink lg:shrink-0 lg:mb-5 lg:relative lg:z-10">
        {{ content.subtitle }}
      </p>
    </SiteLink>
  </li>
</template>

<script lang="ts">
import type { PropType } from 'vue'

import IconSprite from '@/components/helpers/IconSprite.vue'
import ResponsiveImage from '@/components/helpers/ResponsiveImage.vue'
import SiteLink from '@/components/helpers/SiteLink.vue'

export default {
  name: 'LinkCard',
  components: { IconSprite, SiteLink, ResponsiveImage },
  props: {
    content: {
      type: Object as PropType<LinkCard>,
      required: true,
    },
    x: {
      type: Number,
      required: true,
    },
    y: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      ticking: false,
    }
  },
  methods: {
    handleMouseMove(event: MouseEvent) {
      if (!this.ticking) {
        const target = event.currentTarget as HTMLElement
        const rect = target.getBoundingClientRect()

        window.requestAnimationFrame(() => {
          this.$emit('update:hoverCoordinates', {
            x: event.clientX - rect.left,
            y: event.clientY - rect.top,
          })

          this.ticking = false
        })
        this.ticking = true
      }
    },
  },
  emits: ['update:hoverCoordinates'],
}
</script>
